export default __webpack_public_path__ + "static/media/logo.ecc24925.svg";